// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".colorbox{border-radius:.5rem;border-width:1px;display:inline-block;height:.75rem;margin-right:.75rem;width:.75rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
